import React, { createContext, useState } from 'react';

export const ApiRefreshContext = createContext();

export const ApiRefreshProvider = ({ children }) => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  const triggerRefresh = () => {
    // Flip the flag to trigger useEffect in components
    setRefreshFlag(prev => !prev);
  };

  return (
    <ApiRefreshContext.Provider value={{ refreshFlag, triggerRefresh }}>
      {children}
    </ApiRefreshContext.Provider>
  );
};
